export const sendSingleEvent = (clickEvent: Record<string, any>) => {
  // if called in SSR then return
  if (typeof window === 'undefined') {
    return;
  }

  if (window.na && clickEvent?.event_name) {
    window.na.sendEvent(clickEvent.event_name, clickEvent);
  }
};

export const sendPageLoadEvent = (clickEvent: Record<string, any>) => {
  // if called in SSR then return
  if (typeof window === 'undefined') {
    return;
  }

  const pageLoad = {
    ...clickEvent,
    event_type: 'load',
    event_name: 'page_load',
    page_frequency: 1,
    page_url: window?.location.href || '',
  };
  if (window.na) {
    window.na.sendEvent(pageLoad.event_name, pageLoad);
  }
};

export const sendDealPageLoadEvent = (clickEvent: Record<string, any>) => {
  // if called in SSR then return
  if (typeof window === 'undefined') {
    return;
  }

  const pageLoad = {
    ...clickEvent,
    event_type: 'load',
    event_name: 'cart_deals_loaded',
    page_frequency: 1,
    page_url: window?.location.href || '',
  };
  if (window.na) {
    window.na.sendEvent(pageLoad.event_name, pageLoad);
  }
};
